
import { FaRegCircleCheck } from "react-icons/fa6";
import { BsDashLg } from "react-icons/bs";

//single email description
const Emails = ({ onViewHandler, emailDesc }) => {
    console.log("emailDesc", emailDesc)
    return (
        <div className="border p-3 d-flex justify-content-between">
            <div className=" d-flex col-4 p-4 justify-content-between column-gap-4">
                <div className="d-flex flex-column justify-content-center col-4">
                    <h5 className="subTitle">Supplier name</h5>
                    <p className="fs-5 text-truncate d-inline-block">{emailDesc?.supplierName}</p>
                </div>
                <div className="d-flex align-items-center">
                    <div className="border" style={{ height: 30, width: 1 }}></div>
                </div>
                <div className="d-flex flex-column justify-content-center col-4">
                    <h5 className="subTitle">Date/Time</h5>
                    <p className="fs-5">38/07/2024 @ 09:23 PM</p>
                </div>

                <div className="d-flex align-items-center">
                    <div className="border" style={{ height: 30, width: 1 }}></div>
                </div>

                <div className="d-flex flex-column justify-content-center col-4">
                    <h5 className="subTitle">Subject</h5>
                    <p className="fs-5 text-truncate d-inline-block">{emailDesc?.subject}</p>
                </div>
            </div>
            <div className="d-flex justify-content-between column-gap-5">
                <div className=" d-flex col-2 p-4 column-gap-5 justify-content-between">
                    <div className="d-flex flex-column align-items-center row-gap-2">
                        <span>{emailDesc?.opened ? <FaRegCircleCheck color="#65B3E9" size={24} /> : <BsDashLg />}</span>
                        <p className="fs-5">Opened</p>
                    </div>

                    <div className="d-flex flex-column align-items-center row-gap-2">
                        <span>{emailDesc?.replied ? <FaRegCircleCheck color="#65B3E9" size={24} /> : <BsDashLg />}</span>
                        <p className="fs-5">Reply</p>
                    </div>

                    <div className="d-flex flex-column align-items-center row-gap-2">
                        <span>{emailDesc?.unsubscribed ? <FaRegCircleCheck color="#65B3E9" size={24} /> : <BsDashLg />}</span>
                        <p className="fs-5">Unsubscribed</p>
                    </div>
                </div>

                <div className="d-flex align-items-center p-4">
                    <button className="report_button_success" onClick={() => { onViewHandler(emailDesc?.id) }}>View</button>
                </div>
            </div>
        </div>
    )
}

export default Emails